import {combineReducers} from 'redux';
import detailsReducer from "./detailsReducer";
import searchReducer from "./searchReducer";

export default combineReducers ({
  details: detailsReducer,
  search: searchReducer
});